import { Component, OnInit, Input } from '@angular/core';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-update-comercial',
  templateUrl: './update-comercial.component.html',
  styleUrls: ['./update-comercial.component.css'],
})
export class UpdateComercialComponent implements OnInit {
  @Input() modalRef: BsModalRef;

  update: FormGroup;
  name: FormControl;
  name2: FormControl;
  email: FormControl;
  cell: FormControl;
  dni: FormControl;
  lastname: FormControl;
  lastname_2: FormControl;
  cellphone_validate: boolean;
  submitted = false;
  preloader: boolean = false;
  license: any;
  load: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private _http: HttpClient,
    public helper: HelpersService
  ) {}

  ngOnInit() {
    this.updateComercial();
    this.info();
  }

  updateComercial() {
    this.update = this.formBuilder.group({
      name: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      name2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      lastname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      lastname_2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      cell: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      dni: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      email: [null, [Validators.required, Validators.email]],
    });
  }

  get shortUpdate() {
    return this.update.controls;
  }

  info() {
    this._http.get(environment.Api_info_user).subscribe(
      (data) => {
        this.load = false;
        console.log(data);
        this.shortUpdate.name.setValue(data['user_info']['first_name']);
        this.shortUpdate.name2.setValue(data['user_info']['first_name2']);
        this.shortUpdate.lastname.setValue(data['user_info']['last_name']);
        this.shortUpdate.lastname_2.setValue(data['user_info']['last_name2']);
        this.shortUpdate.email.setValue(data['user_info']['email']);
        this.shortUpdate.cell.setValue(data['user_info']['cell']);
        this.shortUpdate.dni.setValue(data['user_info']['dni']);
        this.cellphone_validate = data['cellphone_validated'];
        this.license = data['medic_info']['profesional_license'];
      },
      (error) => {
        this.helper.modalError(
          this.helper.splitErrorMessages(error.error, '<br>')
        );
      }
    );
  }

  updateMedicP() {
    console.log(this.update);
    this.preloader = true;
    if (this.update.valid) {
      let first_name1 = this.shortUpdate.name.value;
      let first_name2 = this.shortUpdate.name2.value;
      let last_name1 = this.shortUpdate.lastname.value;
      let last_name2 = this.shortUpdate.lastname_2.value;
      let email = this.shortUpdate.email.value;
      let cell = this.shortUpdate.cell.value;
      let dni = this.shortUpdate.dni.value;
      let country_code = 57;
      let profesional_license = this.license;
      this._http
        .post(environment.Api_info_user, {
          first_name1,
          first_name2,
          last_name1,
          last_name2,
          cell,
          email,
          dni,
          country_code,
          profesional_license,
        })
        .subscribe(
          (data) => {
            this.preloader = false;
            this.submitted = false;
            this.info();
            console.log(data);
            this.helper.modalSuccess('¡Datos actualizados!');
            this.modalRef.hide();
          },
          (error) => {
            console.log(error);
            this.preloader = false;
            this.submitted = false;
            this.helper.modalError(
              this.helper.splitErrorMessages(error.error, '<br>')
            );
          }
        );
    } else {
      this.submitted = true;
      this.preloader = false;
    }
  }
}
